export default __webpack_public_path__ + "static/media/main-characters-padded-md-1x.d6b3e6ac.jpg";